import { useAsync } from "react-use";
import { action, computed, createContextStore, thunk } from "easy-peasy";
import {
  makeAuthorizedPostRequestToBackend,
  makeUrl,
} from "../helpers/backendApi";
import _ from "lodash";
import { useAppMode } from "../store/model-misc";
import { useCallback } from "react";

const moment = require("moment-timezone");

export function useStatsData() {
  const appMode = useAppMode();
  const handlePlannerStats_1 = StatsStore.useStoreActions(
    (a) => a.plannerStatsTable.handleFetchData
  );
  const handlePlannerStats_2 = useCallback(
    () => handlePlannerStats_1(appMode),
    [handlePlannerStats_1, appMode]
  );
  const { loading: loadingPlannerStats } = useAsync(handlePlannerStats_2, [
    appMode,
  ]);

  const handlePlatformStats_1 = StatsStore.useStoreActions(
    (a) => a.platformStats.handleFetchData
  );
  const handlePlatformStats_2 = useCallback(
    () => handlePlatformStats_1(appMode),
    [handlePlatformStats_1, appMode]
  );
  const { loading: loadingPlatformStats } = useAsync(handlePlatformStats_2, [
    appMode,
  ]);

  const plannerStatsRowData = StatsStore.useStoreState(
    (s) => s.plannerStatsTable.rowData
  );
  if (plannerStatsRowData) {
    plannerStatsRowData.forEach((row) => {
      row.id = ["email"].map((k) => row[k]).join(".");
    });
  }
  const plannerStatsColDefs = StatsStore.useStoreState(
    (s) => s.plannerStatsTable.colDefs
  );

  const plannerStatsData = {
    rowData: plannerStatsRowData,
    colDefs: plannerStatsColDefs,
  };
  const platformStatsData = StatsStore.useStoreState(
    (s) => s.platformStats.psData
  );

  const loading = loadingPlannerStats || loadingPlatformStats;
  const data = {
    plannerStats: plannerStatsData,
    platformStats: platformStatsData,
  };

  return { loading, data };
}

// const BEFORE_THIS_WEBAPPS_LAUNCH_DATE = "2019-11-20T01:00:00.000";

const defaultStartTimestamp = () => ""; //moment().subtract(7, "days");
const defaultEndTimestamp = () => ""; //moment();

export const StatsStore = createContextStore((initialData = {}) => ({
  query: {
    succinct: initialData.succinct || false,
    start_timestamp: _.isUndefined(initialData.start_timestamp)
      ? defaultStartTimestamp()
      : initialData.start_timestamp,
    end_timestamp: _.isUndefined(initialData.end_timestamp)
      ? defaultEndTimestamp()
      : initialData.end_timestamp,
    rangePickerChanged: action((state, [new_start, new_end]) => {
      state.start_timestamp = new_start;
      state.end_timestamp = new_end;
    }),
    payload: computed(({ succinct, start_timestamp, end_timestamp }) => ({
      succinct,
      start_timestamp: start_timestamp && start_timestamp.utc().toISOString(),
      end_timestamp: start_timestamp && end_timestamp.utc().toISOString(),
    })),
  },
  plannerStatsTable: {
    rowData: [],
    colDefs: [],
    receiveData: action((state, payload) => {
      state.rowData = payload.rowData;
      state.colDefs = payload.columnDefs;
    }),
    handleFetchData: thunk(async (actions, appMode, { getStoreState }) => {
      const state = getStoreState();
      const resp = await makeAuthorizedPostRequestToBackend({
        url: makeUrl({ endpoint: "planner_stats", appMode }),
        data: state.query.payload,
      });
      actions.receiveData(resp.data);
    }),
  },
  platformStats: {
    psData: {},
    receiveData: action((state, payload) => {
      state.psData = { ...payload };
    }),
    handleFetchData: thunk(async (actions, appMode, { getStoreState }) => {
      const state = getStoreState();
      const resp = await makeAuthorizedPostRequestToBackend({
        url: makeUrl({ endpoint: "platform_stats", appMode }),
        data: state.query.payload,
      });
      actions.receiveData(resp.data);
    }),
  },
}));
